// extracted by mini-css-extract-plugin
export default {"linkbutton":"PreCadastro_linkbutton__KcEfM","nameCondominium":"PreCadastro_nameCondominium__NesCl","title":"PreCadastro_title__SXajN","cond":"PreCadastro_cond__Yggxb"};